import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import UserAvatarGroup from "@/components/widgets/common/UserAvatarGroup.vue"
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import Home from "@/modules/Missions/components/Details/Overview/Overview.vue"
import Billing from "@/modules/Missions/components/Details/Billing/StaffBilling.vue"
import Documents from "@/modules/Missions/components/Details/Documents/Documents.vue"
import TeamTab from "@/modules/Missions/Staff/TeamTab/TeamTab.vue"
import { useQuery } from "@vue/apollo-composable"
import {
  MissionLifecycleFragmentFragment,
  MissionLifecyclesQuery,
  MissionLifecyclesQueryQuery,
  MissionLifecyclesQueryQueryVariables,
} from "@/gql"
import useRouter from "@/router/useRouter"
import MissionToolbar from "@/modules/Missions/components/Details/MissionToolbar/MissionToolbar.vue"
import { resolveUrl, useUrl } from "@/hooks/useUrl"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import Actions from "@/modules/Missions/components/Details/Actions/ActionsTab.vue"
import { provideMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffDetailPage',
  setup(__props) {

const { router, routes } = useRouter()

const { loading, refetch, onError, onResult } = useQuery<
  MissionLifecyclesQueryQuery,
  MissionLifecyclesQueryQueryVariables
>(MissionLifecyclesQuery, {
  filter: {
    idIn: [router.currentRoute.params.id],
  },
  per: 1,
})

const pageState = ref(PageState.Loading)
const mission = ref<MissionLifecycleFragmentFragment | null>(null)

const { handlePageErrorState } = usePageState(pageState)

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  if (result?.data?.missionLifecycles?.data.length === 0) {
    pageState.value = PageState.Empty
    return
  }

  if (result.data?.missionLifecycles?.data[0].__typename === "MissionLifecycle") {
    mission.value = result.data?.missionLifecycles?.data[0]
  }
})

provideMissionLifecycleContext({ mission: mission, refetch })

const collaborators = computed(() => {
  return mission.value ? mission.value.collaborators : []
})

const tabs = [
  {
    label: "Home",
    key: "home",
  },
  {
    label: "Team",
    key: "team",
  },
  {
    label: "Billing",
    key: "billing",
  },
  {
    label: "Documents",
    key: "documents",
  },
  {
    label: "Actions",
    key: "actions",
  },
]

const projectLink = computed(() => {
  return resolveUrl(useUrl(routes.MissionDetail, { id: mission.value?.id.toString() }).href)
})

return { __sfc: true,router, routes, loading, refetch, onError, onResult, pageState, mission, handlePageErrorState, collaborators, tabs, projectLink, AppDetailPage, UserAvatarGroup, Tab, Tabs, Home, Billing, Documents, TeamTab, MissionToolbar, PageState, PageStateError, Actions }
}

})